export const FETCH_USER_REQUEST = 'FETCH_USER_REQUEST'
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS'
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE'

export const REGISTER_USER = 'REGISTER_USER'
export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS'
export const REGISTER_USER_FAILURE = 'REGISTER_USER_FAILURE'


export const fetchUserData = (isReload) => ({
    type: FETCH_USER_REQUEST,
    payload: isReload
})

export const fetchUserDataSuccess = (user) => ({
    type: FETCH_USER_SUCCESS,
    payload: user
})

export const fetchUserDataFailed = (message) => ({
    type: FETCH_USER_FAILURE,
    payload: message
})



export const register = (user) => ({
    type: REGISTER_USER,
    payload: user
})

export const registerSuccess = (message) => ({
    type: REGISTER_USER_SUCCESS,
    payload: message
})

export const registerFailed = (message) => ({
    type: REGISTER_USER_FAILURE,
    payload: message
})
